import { StyleSheet, Dimensions, Platform } from "react-native";

import AppConfig from "../config/AppConfig";
import { isAndroid, isWeb } from "../helpers/utils";
import AppTheme from "./v3/AppTheme";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");
const MAX_WIDTH = {
  maxWidth: isWeb ? 411 : WIDTH,
};

const shadow = {
  shadowOffset: { width: 0, height: 4 },
  shadowColor: "#000",
  shadowRadius: 3,
  elevation: 5,
  shadowOpacity: 0.1,
};

const appStyles = StyleSheet.create({
  maxWidth: MAX_WIDTH,
  container: {
    position: "relative",
    width: WIDTH,
    height: HEIGHT,
    margin: "auto",
    backgroundColor: "#FFF",
    borderRadius: 4,
    paddingBottom: 0,
    //...(isWeb ? shadow : {}),
    ...MAX_WIDTH,
  },
  containerWeb: {
    position: "relative",
    width: WIDTH,
    height: HEIGHT,
    margin: "auto",
    backgroundColor: "#FFF",
    borderRadius: 4,
    paddingBottom: 0,
  },
  containerNavigation: {
    width: WIDTH,
    display: "flex",
    flex: 1,
    flexShrink: 0,
    flexDirection: "column",
    backgroundColor: "#f8f8f8",
  },
  kbView: {
    height: isAndroid ? HEIGHT - 80 : isWeb ? HEIGHT - 50 : HEIGHT - 75,
  },
  kbViewNoFooter: {
    height: isAndroid ? HEIGHT - 30 : isWeb ? HEIGHT : HEIGHT - 14,
  },
  preList: {
    height: 8,
    backgroundColor: AppTheme.containerBg,
  },
  scrollView: {
    paddingHorizontal: 10,
    marginTop: 8,
    backgroundColor: "#FFF",
  },
  scrollViewContent: {
    paddingBottom: isWeb ? 160 : 260,
  },

  fab: {
    bottom: isWeb ? 50 : 60,
  },
  verticalButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  horizontalButtons: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
  },
  row: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  flex1: {
    flex: 1,
  },
  borderBottom: {
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
  },
  // ------------------------------------- TIMESLOTS -------------------------------------
  timeslotRow: {
    position: "relative",
    backgroundColor: "#FFF",
    //paddingLeft: 34,
    //paddingRight: 0,

    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  timeslot: {
    height: 40,
    borderTopColor: "#F5F5F5",
    borderTopWidth: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  selectedTimeslot: {
    backgroundColor: "rgba(232, 244, 244, 1)",
  },
  timeslotControls: {
    zIndex: 10,
    position: "relative",
    width: 40,
    height: 40,
  },
  timeslotControlIcon: {
    position: "absolute",
    left: 0,
    top: 0,
  },
  activityNameUndo: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
  },
  activityName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "400",
    fontSize: 12,
    lineHeight: 14,
    color: "#2D3142",
  },
  selectedTimeslotText: {
    fontWeight: "600",
  },
  activityIcon: {
    width: 24,
    height: 24,
    marginLeft: 6,
    marginRight: 8,
  },
  captionThin: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    paddingTop: 0,
  },
  // ------------------------------------- ICONS -------------------------------------
  iconContainer: {
    width: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },

  // ------------------------------------- TUTORIALS -------------------------------------
  tutorialsOverlay: {
    width: WIDTH,
    maxWidth: AppConfig.MAX_WIDTH,
    height: isAndroid ? "100%" : HEIGHT,
    zIndex: 10,
    position: "absolute",
    left: 0,
    top: 0,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
  highlightRound: {
    backgroundColor: "#F8E585",
    borderRadius: 100,
  },
  highlightBorder: {
    borderWidth: 4,
    borderColor: "#F8E585",
  },
  highlight: {
    backgroundColor: "#F8E585",
    borderRadius: 16,
  },
  highlightTime: {
    backgroundColor: "#F8E585",
    borderRadius: 12,
    paddingHorizontal: 5,
  },
  highlightJournal: {
    backgroundColor: "#F8E585",
    borderRadius: 20,
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  overlay: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 20,
    backgroundColor: "#FFF",
    opacity: 0.8,
  },
  noResultsText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  wordOverflow: Platform.select({
    ios: {
      overflow: "hidden",
      display: "flex",
    },
    web: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "pre",
    },
  }),

  // ------------------------------------- BOTTOM BUTTONS -------------------------------------
  footerOptions: {
    position: "absolute",
    bottom: isWeb ? 8 : 16,
    left: 0,
    height: "auto",
    width: "100%",
  },
  footerOptionsWhite: {
    backgroundColor: "rgba(255, 255, 255, 0.82)",
    padding: 8,
    shadowOffset: { width: 0, height: -1 },
    shadowColor: "rgba(0, 0, 0, 0.20)",
    borderRadius: 4,
  },
  footerButtons: {
    position: "absolute",
    left: 0,
    bottom: 0,

    backgroundColor: AppTheme.lightGray,
    shadowOffset: { width: 0, height: -1 },
    shadowRadius: 2,
    shadowColor: "rgba(0, 0, 0, 0.25)",
    borderRadius: 4,

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    paddingTop: 20,
    paddingBottom: isWeb ? 20 : 40,
  },
  footerSearch: {
    width: "100%",
    marginRight: 0,
    marginLeft: 0,
  },

  verticalFooterButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  bottomButton: {
    width: 158,
    height: 40,
    paddingHorizontal: 6,
  },
  /* Footer double buttons */
  bottomButtonTwin: {
    flex: 1,
    width: "50%",
    height: 32,
    paddingHorizontal: 8,
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 1 },
    shadowColor: "rgba(0, 0, 0, 0.20)",
    borderRadius: 4,
    shadowOpacity: 0.9,
    elevation: 3,
    overflow: "visible",
  },
  firstTwinButton: {
    marginRight: 6,
  },
  bottomButtonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
  },

  bottomButtonTwinText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});

export default appStyles;
